const pageSeoActionTypes =  {
    SEO_OPEN_NEW_FORM: "SEO_OPEN_NEW_FORM",
    SEO_CLOSE_NEW_FORM: "SEO_CLOSE_NEW_FORM",
    SEO_CHANGE_URL: "SEO_CHANGE_URL",
    SEO_ADD_URL: "SEO_ADD_URL",
    SEO_ADDED_URL: "SEO_ADDED_URL",
    ERROR_SEO_ADDING_URL: "ERROR_SEO_ADDING_URL",
    SEO_OPEN_EDIT_FORM: "SEO_OPEN_EDIT_FORM",
    SEO_CLOSE_EDIT_FORM: "SEO_CLOSE_EDIT_FORM",
    SEO_SAVE_URL: "SEO_SAVE_URL",
    SEO_SAVED_URL: "SEO_SAVED_URL",
    ERROR_SEO_SAVING_URL: "ERROR_SEO_SAVING_URL",
    SEO_DELETE_URL: "SEO_DELETE_URL",
    SEO_DELETED_URL: "SEO_DELETED_URL",
    ERROR_SEO_DELETING_URL: "ERROR_SEO_DELETING_URL"
};

export default pageSeoActionTypes;
